@if (favoriteBooks?.length) {
  <ng-container
    *ngTemplateOutlet="productList; context: { title: 'Favoriete uitgaves', bookTiles: favoriteBooks }"
  ></ng-container>
}

@if (otherBooks?.length) {
  <ng-container
    *ngTemplateOutlet="productList; context: { title: 'Andere uitgaves', bookTiles: otherBooks }"
  ></ng-container>
}

<ng-template #productList let-title="title" let-bookTiles="bookTiles">
  <div class="[ title-medium ]">{{ title }}</div>

  <campus-product-list view="cluster">
    @for (tile of bookTiles; track trackByGuid($index, tile)) {
      <campus-product
        [attr.data-guid]="tile.guid"
        [title]="tile.title"
        [learningAreaName]="tile.data?.method?.learningArea?.name"
        [imageUrl]="tile.logoUrl | methodsImagesPath"
        [rows]="tile.rows"
        (rowClick)="onBookClick($event.data, tile)"
        data-cy="book-tile"
      ></campus-product>
    }
  </campus-product-list>
</ng-template>
